import {
  Array,
  Boolean,
  Null,
  Number,
  Partial,
  Record,
  Static,
  String,
} from "runtypes";

export enum TemplateQuestionType {
  scale,
  written,
}

export enum TemplateQuestionCategory {
  expectations,
  warmth,
  other,
  parent,
}

export class TemplateQuestionUtil {
  public static categoryToString(mode: TemplateQuestionCategory): string {
    return TemplateQuestionCategory[mode];
  }
  public static typeToString(mode: TemplateQuestionType): string {
    return TemplateQuestionType[mode];
  }
}

export const TemplateQuestionRunType = Record({
  category: Number,
  coachText: String,
  id: Number,
  order: Number,
  parentText: String,
  scaleNegativeText: String,
  scalePositiveText: String,
  scaleReversed: Boolean,
  scaleScale: Number,
  studentText: String,
  templateId: Number,
  type: Number,
  status: Boolean
}).And(
  Partial({
    deleted: Boolean,
    scale: Number,
  })
);

export interface ITemplateQuestion
  extends Static<typeof TemplateQuestionRunType> {}

export const TemplateDataRunType = Record({
  defaultNegativeText: String,
  defaultPositiveText: String,
  defaultReversed: Boolean,
  defaultScale: Number,
  enableParentQuestions: Boolean,
  name: String,
  parentId: Number.Or(Null),
  questions: Array(TemplateQuestionRunType),
  type: Number,
});

export interface ITemplateData extends Static<typeof TemplateDataRunType> {}

export interface ITemplate extends ITemplateData {
  id: number;
  ismasterTemplate?: boolean;
}

export const TemplateRunType = Record({
  defaultNegativeText: String,
  defaultPositiveText: String,
  defaultReversed: Boolean,
  defaultScale: Number,
  enableParentQuestions: Boolean,
  id: Number,
  name: String,
  parentId: Number.Or(Null),
  questions: Array(TemplateQuestionRunType),
  type: Number,
});



// WEBPACK FOOTER //
// ./src/api/types/ITemplate.ts